import React, { useState, useEffect } from 'react';
import {
   Backdrop,
   Paper,
   Typography,
   Button,
   Box,
   List,
   ListItem,
   ListItemText,
   ListItemSecondaryAction,
   IconButton,
   Grid,
   Divider,
   Modal,
} from '@material-ui/core';
import LoadingPopup from './../../../components/Loading/LoadingPopup';
import { myContainerStyle, Layout } from '../../../configs/ui/constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { faTrashAlt, faFileEdit } from '@fortawesome/pro-duotone-svg-icons';
import {
   useRouteMatch,
   useParams,
   useHistory,
   Link,
   useLocation,
} from 'react-router-dom';
import PermissionBox from '../../../components/SubMenu/PermissionBox';
import { makeStyles } from '@material-ui/core/styles';
import Create from '../../../components/Modal/Permission/Create';
import Edit from '../../../components/Modal/Permission/Edit';
import Delete from '../../../components/Modal/Permission/Delete';
import Axios from 'axios';

// const permissionList = [
//   {
//     type: 'ผู้บังคับบัญชา',
//     delete: false,
//     id: '001',
//     value: '',
//   },
//   {
//     type: 'พนักงาน ลูกจ้าง',
//     delete: false,
//     id: '002',
//     value: '',
//   },
//   {
//     type: 'Specialist',
//     delete: false,
//     id: '003',
//     value: '',
//   },
// ];
function useQuery() {
   return new URLSearchParams(useLocation().search);
}
const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));
const PermissionManagement = (props) => {
   const classes = useStyles();
   let query = useQuery();
   let { path, url } = useRouteMatch();
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const [permissionList, setPermissionList] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const setModalStyle = (type, value) => {
      if (type === 'create') {
         setMyModal(
            <Create
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'edit') {
         setMyModal(
            <Edit
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'delete') {
         setMyModal(
            <Delete
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };
   const refreshData = () => {
      setShowModal(false);
      getData();
   };
   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/permission/GetPermissionListMobile')
         .then((resp) => {
            setPermissionList(
               resp.data.map((el) => {
                  return {
                     ...el,
                     type: el.permissionGroupNameTh,
                     delete: el.isCanDelete,
                     id: el.permissionGroupId,
                  };
               }),
            );
         })
         .catch()
         .finally(() => {
            setIsLoading(false);
         });
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <Box my={1}>
            <Box display='flex' alignItems='center'>
               <Box mx={1}>
                  <Typography variant='h5'>
                     จัดการสิทธิ์ใช้งาน Mobile
                  </Typography>
               </Box>
               {/*<Box mx={1}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => {
                setModalStyle('create', '');
              }}
            >
              เพิ่มสิทธิ์
            </Button>
          </Box>*/}
            </Box>
            <Box mx={1}>
               <Typography>จัดการสิทธิ์พนักงาน</Typography>
            </Box>
            <Box mx={1}>
               <Typography>
                  เพิ่มผู้ใช้งาน กำหนดสิทธิ์
                  หรือกำหนดค่าเริ่มต้นให้กลุ่มผู้ใช้งาน
               </Typography>
            </Box>
         </Box>
         <Grid container direction='row' justify='center'>
            <Grid item xs={4}>
               <Box borderRadius='borderRadius' boxShadow={1} p={2}>
                  {/*<Typography>กลุ่ม</Typography>*/}
                  {/*<Divider />*/}
                  <List>
                     {permissionList.map((value, idx) => (
                        <React.Fragment key={idx}>
                           <ListItem
                              button
                              // className={classes.nested}
                              {...{
                                 to: `/private/admin/permission?id=${value.id}&type=${value.type}`,
                              }}
                              component={Link}
                              onClick={getData}
                           >
                              <ListItemText primary={value.type} />
                              {/*<ListItemSecondaryAction>
                      <IconButton onClick={() => setModalStyle('edit', value)}>
                        <FontAwesomeIcon color={'#00a2e8'} icon={faFileEdit} />
                      </IconButton>
                      {value.delete && (
                        <IconButton
                          onClick={() => setModalStyle('delete', value)}
                        >
                          <FontAwesomeIcon
                            color={'#ed1c24'}
                            icon={faTrashAlt}
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>*/}
                           </ListItem>
                        </React.Fragment>
                     ))}
                  </List>
               </Box>
            </Grid>
            <Grid item xs={8}>
               <Box borderRadius='borderRadius' boxShadow={1} p={2}>
                  <PermissionBox
                     id={query.get('id')}
                     type={query.get('type')}
                     permission={permissionList}
                     refreshData={refreshData}
                  />
               </Box>
            </Grid>
         </Grid>
      </Paper>
   );
};

export default PermissionManagement;
